import { render, staticRenderFns } from "./NotificationsSettingsFormSalvages.vue?vue&type=template&id=4c6f7c62"
import script from "./NotificationsSettingsFormSalvages.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsFormSalvages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports